import React from 'react';
import Pagination from '../components/paginaton';
import Category from '../components/category';
import HomeLinks from '../components/homeLinks';

const Home = () => {
  return (
    <div>
      <HomeLinks/>
    </div>
  );
};

export default Home;